export default {

  language: {
    title: 'Selecione um idioma',
    info: 'Clique para alterar o idioma',
    portuguese: 'Português',
    english: 'Inglês'
  }
}
